import { useIntl } from 'react-intl'

import { priceGetFormattedPrice } from '../../../../price'
import { useProductPageContext } from '../../productPageContext'

export const useCrossSellListPriceQueryParam = (): string | undefined => {
  const intl = useIntl()

  const { currentOffer } = useProductPageContext()

  const { offerPrice, strikeThroughOfferPrice } = currentOffer ?? {}

  if (!strikeThroughOfferPrice) {
    return undefined
  }

  const {
    additionalInformation,
    currency,
    price: amount,
  } = strikeThroughOfferPrice

  const { netPrice } = additionalInformation ?? {}

  const net = netPrice ?? offerPrice?.additionalInformation?.netPrice

  const formatted = priceGetFormattedPrice(amount ?? 0, intl)

  return JSON.stringify({
    amount,
    currency,
    formatted,
    net,
    type: 'list',
  })
}
